module.exports = __webpack_public_path__ + "static/media/arrow-divider.034d18a6.svg";